export const MAIN_COLOR = "#00264d";
export const SECONDARY_COLOR = "#fbb731";
export const BLACK_COLOR = "#262626";
export const LIGHT_GREY_COLOR = "#d8d8d8";
export const MEDIUM_GREY_COLOR = "#e3e3e3";
export const DARK_GREY_COLOR = "#3d3d3d";
export const PARAGRAPH_FONT = "Open Sans, sans-serif";
export const HEADER_FONT = "ASAP, sans-serif";
export const NAV_HEIGHT = 70;



// WEBPACK FOOTER //
// ./src/styles/variables.js